// components/common/avatar/cropper/helpers/cropImage.ts

export const getCroppedImg = async (
  imageSrc: string,
  crop: any,
  shape: "circle" | "rounded" = "circle"
): Promise<string | null> => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) return null;

  // Always use square canvas
  const size = Math.max(crop.width, crop.height);
  canvas.width = size;
  canvas.height = size;

  // Draw the cropped image into the canvas
  ctx.drawImage(
    image,
    crop.x,
    crop.y,
    crop.width,
    crop.height,
    0,
    0,
    size,
    size
  );

  // If circular shape is requested, apply a circular mask
  if (shape === "circle") {
    const maskedCanvas = document.createElement("canvas");
    maskedCanvas.width = size;
    maskedCanvas.height = size;
    const maskedCtx = maskedCanvas.getContext("2d");
    if (!maskedCtx) return null;

    // Draw the base image first
    maskedCtx.drawImage(canvas, 0, 0);

    // Create circular mask
    maskedCtx.globalCompositeOperation = "destination-in";
    maskedCtx.beginPath();
    maskedCtx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    maskedCtx.fill();

    // Export from masked canvas
    return new Promise((resolve) => {
      maskedCanvas.toBlob((blob) => {
        if (!blob) return resolve(null);
        const url = URL.createObjectURL(blob);
        resolve(url);
      }, "image/jpeg");
    });
  }

  // If no mask needed (rounded), export square image
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      if (!blob) return resolve(null);
      const url = URL.createObjectURL(blob);
      resolve(url);
    }, "image/jpeg");
  });
};

// Helper function to load image from URL
const createImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (err) => reject(err));
    image.setAttribute("crossOrigin", "anonymous"); // handle CORS
    image.src = url;
  });
